<button
  type="button"
  (click)="toggleDropdown($event)"
  class="flex items-center justify-between px-4 py-2 bg-white border-1 border-blue-500 text-blue-500 rounded-full min-w-40 hover:border-blue-600 hover:text-blue-600 focus:outline-none transition-all duration-200"
  [attr.aria-haspopup]="true">
  
  <span class="text-sm font-medium">Curso {{ selectedOption()?.year }}</span>
  
  <i class="pi pi-chevron-down text-xs ml-2"></i>
</button>

@if (options().length > 0) {
<p-popover #schoolYearMenu>
  <div class="min-w-40">
    <ul class="m-0">
      @for (option of options(); track option.id) {
        <li 
          (click)="selectOption(option)"
          class="px-3 py-2 hover:bg-gray-50 cursor-pointer text-sm rounded transition-colors duration-150"
          [class.bg-gray-100]="selectedOption()?.id === option.id"
          [class.font-medium]="selectedOption()?.id === option.id">
          {{ option.year }}
        </li>
      }
    </ul>
  </div>
</p-popover>
}